import { Component } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../_models/ITranslations";
import { TranslationService } from "../../_services/translation.service";
import { StoriesTypes } from "../stories/stories-types";
import { DevToolsService } from "../../_services/dev-tools.service";
import { StoriesComponent } from "../stories/stories.component";

@Component({
  selector: "last-stories-component",
  template: ` <div
    style="direction: ltr"
    class="flex flex-col items-start w-full p-7 gap-8"
  >
    <h1 class="m-4 text-2xl font-bold">Last stories</h1>
    <section class="flex-row flex  w-full gap-4 ">
      <div *ngFor="let story of lastStoriesLinks" class="flex flex-row  ">
        <a
          [routerLink]="['stories', story.path]"
          style="background-color: #9ee1f1"
          class="flex flex-row p-4 items-center justify-center   h-12 rounded-full   font-bold  shadow"
        >
          {{ story.name }}
        </a>
      </div>
    </section>
    <div *ngIf="lastStoriesLinks.length">
      <button
        (click)="clearLastStories()"
        style="background-color: rgba(189,62,62,0.5)"
        class="flex flex-row p-4 items-center justify-center   h-12 rounded-full   font-bold  shadow outline-none"
      >
        Clear
      </button>
    </div>
  </div>`,
  styleUrls: ["../../../css/tailwind-utils.scss"],
})
export class LastStoriesComponent {
  public translations$: Observable<ITranslations>;
  public lastStoriesLinks: Array<{
    path: string;
    name: string;
    key: StoriesTypes;
  }> = [];

  constructor(
    private translationService: TranslationService,
    private devToolsService: DevToolsService
  ) {
    this.translations$ = this.translationService.translations;
    const lastStories = Array.from(
      new Set(this.devToolsService.viewedStories.slice(-5))
    );

    this.lastStoriesLinks = DevToolsService.convertStoriesToLinks(lastStories);
  }

  public clearLastStories() {
    this.devToolsService.clearLastStories();
    this.lastStoriesLinks = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/development/last-stories/last-stories.component.ts